import {useSelector} from 'react-redux';

import {errorMessagesSelector} from 'features/error-messages/selectors';

export const useErrorMessage = () => {
    const errorMessages = useSelector((state) => errorMessagesSelector(state));

    let errorMessage = null;

    if (Array.isArray(errorMessages) && errorMessages.length > 0) {
        errorMessage = errorMessages.shift();
    }

    return errorMessage;
};
